/* eslint-disable max-classes-per-file */

import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { ICrewMemberUpdate, IPaxUpdate, ITripCreate, ITripResponse } from '../../models/trip.model';

export class LoadTrips {
  static readonly type = '[Trips] Load Trips via Service';
  constructor(public filter?: MainTableFilterModel, public departmentId?: string) {}
}

export class LoadTripsForTenant {
  static readonly type = '[Trips] Load Trips via Service for Tenant';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAvailableTrips {
  static readonly type = '[Trips] Load All Trips via Service';
  constructor() {}
}

export class LoadTripById {
  static readonly type = '[Trips] Load Trip By Id via Service';
  constructor(public id: string, public departmentId?: string) {}
}

export class CreateTrip {
  static readonly type = '[Trips] Create Trip';
  constructor(public trip: ITripCreate) {}
}

export class UpdateTripForActivityBased {
  static readonly type = '[Trips] Update Trip For Activity Based';
  constructor(public trip: ITripResponse | ITripCreate) {}
}

export class UpdateTripForTripBased {
  static readonly type = '[Trips] Update Trip For Trip Based';
  constructor(public trip: ITripCreate) {}
}

export class EndTrip {
  static readonly type = '[Trips] End Trip';
  constructor(public tripId: string, public endDate: Date) {}
}

export class PrintTripPdf {
  static readonly type = '[Trips] Print Trip';
  constructor(public tripId: string, public onlyCurrentlyOnBoard: boolean) {}
}

export class DeleteTrip {
  static readonly type = '[Trips] Delete Trip';
  constructor(public tripId: string) {}
}

export class LoadTripLog {
  static readonly type = '[Trips] Load Trip Log';
  constructor(public tripId: string) {}
}

export class AddCrewMembersToTrip {
  static readonly type = '[Trips] Add Crew Members To Trip';
  constructor(public tripId: string, public userIds: string[]) {}
}

export class UpdateCrewMember {
  static readonly type = '[Trips] Update Crew Member';
  constructor(
    public tripId: string,
    public crewMemberId: string,
    public crewMember: ICrewMemberUpdate
  ) {}
}

export class DeleteCrewMemberFromTrip {
  static readonly type = '[Trips] Delete Crew Member From Trip';
  constructor(public tripId: string, public crewMemberIds: string[]) {}
}

export class AddPaxesToTrip {
  static readonly type = '[Trips] Add Paxes To Trip';
  constructor(public tripId: string, public paxesId: string[]) {}
}

export class DeletePaxFromTrip {
  static readonly type = '[Trips] Delete Pax From Trip';
  constructor(public tripId: string, public paxIds: string[]) {}
}

export class UpdatePax {
  static readonly type = '[Trips] Update Pax';
  constructor(public tripId: string, public paxId: string, public pax: IPaxUpdate) {}
}

export class LoadTripsChangeLog {
  static readonly type = '[Trips] Load Trips Change Log';
  constructor(public filter?: MainTableFilterModel) {}
}
